enum TextAlignment {
  Start = 'start',
  End = 'end',
  Center = 'center'
};

export default TextAlignment;
